export default __webpack_public_path__ + "static/novaya-white-crop-ebdb5827696da96139d9355aca297449.png";